import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

/**
 * Returns a copy of the filters map whose range ends tomorrow when the picked range ends today —
 * `Today` goes out as today → tomorrow, a custom `2026-11-02` → today as `2026-11-02` → tomorrow —
 * so the whole of today falls inside it. The start date is never moved.
 *
 * The filter itself keeps the picked end date (it feeds the date picker and local storage), hence
 * the copy: only the payload sent with a report request carries tomorrow.
 */
export default function includeTodayFilterDates(filters) {
    const end_date = filters?.dates?.values?.end_date;

    if (!end_date?.value || !moment(end_date.value).isSame(moment(), 'day')) return filters;

    return {
        ...filters,
        dates: {
            ...filters.dates,
            values: {
                ...filters.dates.values,
                end_date: { ...end_date, value: moment().add(1, 'days').format(DATE_FORMAT) },
            },
        },
    };
}
